module.exports = __webpack_public_path__ + "img/59.c9cd08b4.jpg";